import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { UtilDistributionBand } from '../../../../utils/projectOverviewCharts'
import { overviewRechartsPalette } from './overview-recharts-palette'

export interface OverviewUtilDistributionBarChartProps {
  isDark: boolean
  data: UtilDistributionBand[]
}

export function OverviewUtilDistributionBarChart({
  isDark,
  data,
}: OverviewUtilDistributionBarChartProps) {
  const { grid, tick, tooltipBg, tooltipBorder } = overviewRechartsPalette(isDark)
  const hasData = data.some((b) => b.count > 0)

  return (
    <div className="rounded-xl shadow-md border border-slate-200 bg-white p-4 min-h-[280px]">
      <h3 className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-3">
        Utilization distribution
      </h3>
      <p className="text-xs mb-2 text-slate-500">Projects by utilization band</p>
      {hasData ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 8, right: 24, left: 4, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke={grid} opacity={0.8} />
            <XAxis type="number" stroke={tick} tick={{ fontSize: 11 }} />
            <YAxis
              type="category"
              dataKey="name"
              stroke={tick}
              tick={{ fontSize: 11 }}
              width={80}
              interval={0}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: tooltipBg,
                border: `1px solid ${tooltipBorder}`,
                borderRadius: 8,
                fontSize: 12,
              }}
              formatter={(value: number) => [`${value} projects`, 'Count']}
            />
            <Bar dataKey="count" radius={[0, 4, 4, 0]} barSize={28}>
              {data.map((entry, i) => (
                <Cell key={i} fill={entry.fill} stroke="#475569" strokeWidth={1} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[260px] flex items-center justify-center text-xs text-slate-500">
          No project data
        </div>
      )}
    </div>
  )
}
